﻿import './tracker.config';

import TKModuleFactory from '@tk/utilities/tk.module.factory';
import { headerComponents } from './header';
import TKManager from '@tk/basics/tk.manager';
import TKTable from '@tk/components/tk.table';
import TKFormDatepicker from '@tk/controls/tk.form.datepicker';
import TKFormElement from '@tk/controls/tk.form.element';
import TKFormValidator from '@tk/controls/tk.form.validator';
import TKFormZipCity from '@tk/controls/tk.form.zipcity';
import TKDialog from '@tk/components/tk.dialog';
import TKPrice from '@tk/components/tk.price';
import TKStock from '@tk/components/tk.stock';
import TKTabsAccordion from '@tk/controls/tk.tabs.accordion';
import TKStaticContent from '@tk/controls/tk.static.content';
import TKContextMenu from '@tk/components/tk.context.menu';
import TKDashboard from '@tk/components/tk.dashboard';
import TKDashboardWidget from '@tk/components/tk.dashboard.widget';
import TKArticleList from '@tk/components/tk.article.list';
import TKStatusConsole from '@tk/components/tk.status.console';
import TKClipboard from '@tk/components/tk.clipboard';
import TKTracker from '@tk/components/tracker/tk.tracker';
import TKTracking from '@tk/components/tracker/tk.tracking';
import TKFilter from '@tk/components/tk.filter';
import TKFilterChip from '@tk/components/tk.filter.chip';
import TKFilterResult from '@tk/components/tk.filter.result';
import TKFilterDropdown from '@tk/components/tk.filter.dropdown';
import TKFilterGroupWrapper from '@tk/components/tk.filter.group.wrapper';
import TKFilterGroup from '@tk/components/tk.filter.group';
import TKFilterSearch from '@tk/components/tk.filter.search';
import TKFilterSelectReset from '@tk/components/tk.filter.select.reset';
import TKFilterDrilldownButton from '@tk/components/tk.filter.drilldown.button';
import TKAsyncForm from '@tk/components/tk.async.form';
import TKAsyncPaging from '@tk/components/tk.async.paging';
import TKCompareStore from '@tk/components/compare/tk.compare.store';
import { configureStore } from '@tk/utilities/tk.use.store';

import 'flatpickr/dist/flatpickr.min.css';
import 'gridstack/dist/gridstack.min.css';
import '@scss/modules/account.scss';

const compareStore = new TKCompareStore();

configureStore({
    compareStore,
});

export default class Account extends TKModuleFactory {
    constructor() {
        super([
            ...headerComponents,
            { name: 'tk-manager', constructor: TKManager },
            { name: 'tk-tracker', constructor: TKTracker },
            { name: 'tk-status-console', constructor: TKStatusConsole },
            { name: 'tk-clipboard', constructor: TKClipboard },
            { name: 'tk-table', constructor: TKTable },
            { name: 'tk-form-zip-city', constructor: TKFormZipCity },
            { name: 'tk-form-validator', constructor: TKFormValidator },
            { name: 'tk-form-datepicker', constructor: TKFormDatepicker },
            { name: 'tk-form-element', constructor: TKFormElement },
            { name: 'tk-dialog', constructor: TKDialog },
            { name: 'tk-price', constructor: TKPrice },
            { name: 'tk-stock', constructor: TKStock },
            { name: 'tk-tabs-accordion', constructor: TKTabsAccordion },
            { name: 'tk-static-content', constructor: TKStaticContent },
            { name: 'tk-context-menu', constructor: TKContextMenu },
            { name: 'tk-dashboard', constructor: TKDashboard },
            { name: 'tk-dashboard-widget', constructor: TKDashboardWidget },
            { name: 'tk-article-list', constructor: TKArticleList },
            { name: 'tk-tracking', constructor: TKTracking },
            { name: 'tk-filter', constructor: TKFilter },
            { name: 'tk-filter-chip', constructor: TKFilterChip },
            { name: 'tk-filter-result', constructor: TKFilterResult },
            { name: 'tk-filter-dropdown', constructor: TKFilterDropdown },
            { name: 'tk-filter-group-wrapper', constructor: TKFilterGroupWrapper },
            { name: 'tk-filter-group', constructor: TKFilterGroup },
            { name: 'tk-filter-search', constructor: TKFilterSearch },
            { name: 'tk-filter-select-reset', constructor: TKFilterSelectReset },
            { name: 'tk-filter-drilldown-button', constructor: TKFilterDrilldownButton },
            { name: 'tk-async-form', constructor: TKAsyncForm },
            { name: 'tk-async-paging', constructor: TKAsyncPaging },
        ]);
    }
}

new Account();
